import { CasinoSearchResultDto } from '@/api/player-api/api-models'
import { toCasinoGameItems } from '@/features/casino/casino.mapper'
import { SearchItem, SearchView } from './search.model'

/**
 * The API answers one flat list, each game tagged with its category and
 * subcategory; phase 1 shows it as one list, as the Favorites screen does.
 * The only seam to change for sections.
 */
export function toCasinoSearchView(result: CasinoSearchResultDto): SearchView {
	const games = result?.games ?? []
	// Index for index with games: the card's data is the lobby's own game item,
	// so a hit launches exactly as a tap on a lobby card does.
	const gameItems = toCasinoGameItems(games)
	const seen = new Set<number>()
	const items: SearchItem[] = []

	games.forEach((game, index) => {
		// The API lists a game once per category it is found in.
		if (seen.has(game.gameId)) return

		const gameItem = gameItems[index]

		seen.add(game.gameId)
		items.push({
			type: 'game',
			key: `game:${game.gameId}`,
			label: gameItem.name,
			imageUrl: gameItem.image,
			providerName: game.gameProvider ?? '',
			category: game.category ?? '',
			followers: game.favoriteCount ?? 0,
			// Dev sends 0 rather than leaving it out; no game pays back nothing.
			rtp: game.rtp ? game.rtp : null,
			playing: game.inPlay ?? 0,
			flatIndex: items.length,
			data: gameItem
		})
	})

	const sections = items.length > 0 ? [{ key: 'game', titleKey: 'other.games', items }] : []

	return { sections, flatItems: items, totalCount: items.length }
}
